import { InputProps } from "PFComponents/text/input";
import { InputFieldSet, InputFieldSetProps } from "PFComponents/text/input_field_set";
import { useDebounce } from "PFCore/helpers/use_debounce";
import { useCallback, useEffect, useState } from "react";

const DEBOUNCE_TIME = 1500;

type SearchItemProps = Pick<
  InputFieldSetProps,
  "error" | "autofocus" | "disabled" | "label" | "labelIcons"
> & {
  handleChange: InputProps["onChange"];
  handleBlur: InputProps["onBlur"];
  handleFocus: InputProps["onFocus"];
  filter: { title: string; value?: string; required?: boolean };
};

export const SearchItem = ({
  filter,
  handleChange,
  handleBlur,
  handleFocus,
  ...inputProps
}: SearchItemProps) => {
  const [value, setValue] = useState(filter.value);
  const debouncedHandleChange = useDebounce(handleChange!, DEBOUNCE_TIME);

  const onChange = useCallback(
    (value, valueObject) => {
      setValue(value);
      debouncedHandleChange(value, valueObject);
    },
    [debouncedHandleChange]
  );

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setValue(filter.value || "");
  }, [filter.value]);

  return (
    <InputFieldSet
      value={value}
      required={filter.required}
      onChange={onChange}
      onBlur={handleBlur}
      onFocus={handleFocus}
      {...inputProps}
    />
  );
};
